module.exports = __webpack_public_path__ + "media/images/heroes/home-29b13ecbf3909622e1de5ea658939151.png";